export enum EMaskShapeType {
    SHAPE_1 = 'shape_1',
    SHAPE_2 = 'shape_2',
    SHAPE_3 = 'shape_3',
    SHAPE_4 = 'shape_4',
    SHAPE_5 = 'shape_5',
    SHAPE_6 = 'shape_6',
    SHAPE_7 = 'shape_7',
    SHAPE_8 = 'shape_8',
    SHAPE_9 = 'shape_9',
    SHAPE_10 = 'shape_10',
}
